import axios from 'axios';

const state = () => ({
  userDetails: {},
  presets: [],
});

const getters = {
  userDetails: state => {
    return state.userDetails;
  },
  presets: state => {
    return state.presets;
  },
};

const mutations = {
  setUserDetails(state, userDetails) {
    state.userDetails = userDetails;
  },
  updateUser(state, data) {
    state.userDetails[data.key] = data.value;
  },
  setPresets(state, payload) {
    state.presets = payload.presets.map(item => {
      return {
        value: item['id'],
        text: item['name'],
        applications: item['apps'],
      };
    });
    state.presets.unshift({ value: 'none', text: 'None', applications: [] });
  },
  setAnonymousUserData(state, data) {
    // vue keys - to be used in the reusable parts like person details
    state.userDetails['firstName'] = data.for.firstName;
    state.userDetails['lastName'] = data.for.lastName;
    state.userDetails['email'] = data.for.selectedEmail;
    state.userDetails['selectedEmail'] = data.for.selectedEmail;
    state.userDetails['confirmEmail'] = data.for.confirmEmail;
    state.userDetails['phoneNumber'] = data.for.phoneNumber;
    //salesforce keys for anonymous requests saving
    state.userDetails['UserFirstName'] = data.for.firstName;
    state.userDetails['UserLastName'] = data.for.lastName;
    state.userDetails['UserEmailId'] = data.for.selectedEmail;
    state.userDetails['UserPhoneNumber'] = data.for.phoneNumber;
    state.userDetails['RequestorFirstName'] = data.by.firstName;
    state.userDetails['RequestorLastName'] = data.by.lastName;
    state.userDetails['RequestorEmailId'] = data.by.selectedEmail;
  },
};

export const actions = {
  async getAccessRequestPresets({ commit }, payload) {
    try {
      let url = `/api/get-access-request-presets`;
      if (payload.token) {
        url = `/api/anonymous/get-access-request-presets?token=${payload.token}`;
      }
      let response = await axios.get(url, {
        params: {
          studyId: payload.studyId,
        },
      });
      if (response.status !== 204) {
        commit('setPresets', {
          presets: response.data['items'],
        });
      }
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
